import React, { useEffect, useState } from "react";
// import TabMenuItem from "../ParticipantRecords/ParticipantTabs/TabMenuItem";
import { Stack } from "@mui/material";
import { PanelWrapper } from "./style";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import {
  setCategory,
  reset as resetSlice,
} from "../../../Redux/reducers/appCustomizationSlice";
import TabMenuItem from "../../ParticipantRecords/ParticipantDetails/TabMenuItem";

export type MenuItemType = {
  key: string;
  label: string;
};

const CustomizationMenuPanel: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedCategory = useAppSelector(
    (state) => state.appCustomization.category
  );
  const [categories, setCategories] = useState<MenuItemType[]>([]);

  useEffect(() => {
    const displayItems: MenuItemType[] = [
      {
        key: "home",
        label: "Home",
      },
      {
        key: "menu",
        label: "Menu",
      },
      {
        key: "urls",
        label: "URLs",
      },
    ];
    setCategories(displayItems);

    const category =
      sessionStorage.getItem("app-category") || displayItems[0].key;

    dispatch(setCategory(category));
    sessionStorage.setItem("app-category", category);

    return () => {
      sessionStorage.removeItem("app-category");
      dispatch(resetSlice());
    };
  }, [dispatch, setCategories]);

  const handleClick = (value: string) => {
    dispatch(setCategory(value));
    sessionStorage.setItem("app-category", value);
  };

  return (
    <Stack sx={PanelWrapper} gap={1}>
      {categories.map((category: MenuItemType) => (
        <TabMenuItem
          key={category?.key}
          active={selectedCategory === category?.key}
          value={category?.key}
          label={category?.label}
          handleClick={handleClick}
        />
      ))}
    </Stack>
  );
};

export default CustomizationMenuPanel;
